var map = {
	"./CleFactura.png": 2881,
	"./ContactUs.svg": 8437,
	"./CopyIcon.svg": 4139,
	"./Dining.svg": 7948,
	"./Discuss.svg": 6423,
	"./EmptyCart.svg": 6968,
	"./Feedback.svg": 6642,
	"./Google.svg": 7318,
	"./Heart.png": 927,
	"./Hotel.svg": 8707,
	"./LOGIN.svg": 9946,
	"./Loading.svg": 2905,
	"./Login_Image.svg": 1512,
	"./Order.svg": 905,
	"./OrderSuccess.gif": 1937,
	"./Tforte.png": 2787,
	"./USER_ICON.png": 4716,
	"./heart_suit_color.svg": 8687,
	"./heart_suit_flat.svg": 943,
	"./ice-cream.png": 6067,
	"./icons8-waving-hand-emoji-48.png": 1846,
	"./juice.png": 6191,
	"./meat.png": 2170,
	"./neutral_face_color.svg": 2736,
	"./smiling_face_3d.png": 5020,
	"./smiling_face_with_smiling_eyes_3d.png": 8016,
	"./star.png": 6035,
	"./vegan.png": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;